import { render, staticRenderFns } from "./EditTPApplicationQuestionButton.vue?vue&type=template&id=6fdbc01c&"
import script from "./EditTPApplicationQuestionButton.vue?vue&type=script&lang=js&"
export * from "./EditTPApplicationQuestionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports